import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  DeleteBar,
  FlexContainer,
} from "../../../../constants/assets/containers";
import Delete from "sushiweb/Icons/all/Delete";
import * as DriverNotificationActions from "../../../../store/actions/DriverNotification";
import Input from "sushiweb/InputTypes/Input";
import Textarea from "sushiweb/InputTypes/Textarea";
import PaginatedReactDropdown from "../../../../components/Common/PaginatedReactDropdown";
import variables from "../../../../constants/assets/variables";
import AddCTAModal from "./AddCTAModal";
import ImageUploader from "../../../Common/ImageUploader";
import CameraAdd from "sushiweb/Icons/all/CameraAdd";
import NoFooterModal from "../../../Common/NoFooterModal";

const LanguageContent = (props) => {
  const {
    isDefault,
    key,
    languageIndex,
    inputFieldState,
    setInputFieldState,
    newCampaignOptions,
    isPopup,
    uploadCampaignImage,
    uploadedImageName,
  } = props;

  const getInputLabel = (val, options, fromKey, toKey) => {
    if (Object.keys(newCampaignOptions).length > 0) {
      const activeElement = options.find((item) => item[fromKey] === val);
      return activeElement ? activeElement[toKey] : val;
    }
    return val;
  };

  const [modalState, setModalState] = useState(false);
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");

  const mediaTypeOptions = [
    { label: "No Media (text only)", value: "TEXT_ONLY" },
    { label: "Image", value: "IMAGE" },
    { label: "Audio", value: "AUDIO" },
    { label: "Video", value: "VIDEO" },
  ];
  const videoOrientationOptions = [
    { label: "Portrait", value: "PORTRAIT" },
    { label: "Landscape", value: "LANDSCAPE" },
  ];

  const handleCTADelete = (index) => {
    const values = { ...inputFieldState };
    values.notification_details[languageIndex]["actions"].splice(index, 1);
    setInputFieldState(values);
  };

  const handleImageChange = (file) => {
    //make api call -> image upload
    const payload = {
      filename: file.name,
    };
    uploadCampaignImage(payload).then((res) => {
      setDownloadUrl(res.download_url);
      setCallback_key(res.callback_key);
      setPresign_url(res.upload_url);
    });
  };

  const handleImageUrlChange = () => {
    const values = { ...inputFieldState };
    values.notification_details[languageIndex]["image"] = downloadUrl;
    values.notification_details[languageIndex]["image_name"] =
      uploadedImageName;
    setInputFieldState(values);

    // now, resetting the callback key and presign url
    setCallback_key("");
    setPresign_url("");
    setDownloadUrl("");
    setModalState(false);
  };

  const isOptionDisabled = (option) => {
    let disable = false;
    inputFieldState.notification_details.forEach((detailsJson, index) => {
      let lang = getInputLabel(
        detailsJson.language,
        newCampaignOptions.languages,
        "value",
        "label"
      );

      if (lang == option && index != languageIndex) {
        disable = true;
      }
    });
    return disable;
  };

  const handleImageModalClose = () => {
    setModalState(false);
  };

  const getModal = () => {
    switch (modalState) {
      case "cta":
        return (
          <AddCTAModal
            setModalState={setModalState}
            inputFieldState={inputFieldState}
            setInputFieldState={setInputFieldState}
            languageIndex={languageIndex}
            getInputLabel={getInputLabel}
            newCampaignOptions={newCampaignOptions}
            key={key}
            notification_for={inputFieldState.notification_for}
          />
        );
      case "image_upload":
        return (
          <NoFooterModal
            header={true}
            heading={`Upload ${
              inputFieldState.notification_details[languageIndex].media.type ==
              "VIDEO"
                ? "Thumbnail"
                : ""
            } Image`}
            handleClose={handleImageModalClose}
            id="campaignImageUploadModal"
          >
            <FlexContainer justify="flex-start">
              <FlexContainer>
                <ImageUploader
                  handleImageChange={handleImageChange}
                  id={`imageUpload${key}`}
                  state="Add"
                  imageKey={"thumbnail"}
                  uploadUrl="/notification_campaign/upload_image/ack"
                  callback_key={callback_key}
                  presign_url={presign_url}
                  keyName="callback_key"
                  maxSize={1}
                  handleImageUrlChange={handleImageUrlChange}
                />
                <div className="flex mb-26 ml-26 text-grey pill">
                  <ul>
                    <li>Maximum Image Size: 1 MB</li>
                    <li>Supported types: PNG/JPG/JPEG</li>
                  </ul>
                </div>
              </FlexContainer>
            </FlexContainer>
          </NoFooterModal>
        );
    }
  };

  const handleChange = (key, val) => {
    if (key == "type") {
      const values = { ...inputFieldState };
      values.notification_details[languageIndex]["image"] = "";
      values.notification_details[languageIndex]["image_name"] = "";
      setInputFieldState(values);
    }

    if (key == "type" || key == "url" || key == "orientation") {
      var mediaDetails =
        inputFieldState.notification_details[languageIndex].media;
      mediaDetails[key] = val;
      key = "media";
      val = mediaDetails;
    }

    const values = { ...inputFieldState };
    values.notification_details[languageIndex][key] = val;
    setInputFieldState(values);
  };

  return (
    <LanguageSection>
      <p className="sectionHeading">
        {isDefault ? "DEFAULT" : "ADDITIONAL"} LANGUAGE CONTENT
      </p>
      {newCampaignOptions.languages && (
        <FlexContainer>
          <p className="langText">
            {isDefault ? "Default language" : "Language"}
          </p>
          <div className="langDropdown">
            <PaginatedReactDropdown
              placeholder=""
              options={newCampaignOptions.languages}
              labelKey="label"
              valueKey="value"
              data-testid={`newCampaignLanguage${key}`}
              value={getInputLabel(
                inputFieldState.notification_details[languageIndex].language,
                newCampaignOptions.languages,
                "value",
                "label"
              )}
              isOptionDisabled={isOptionDisabled}
              handleChange={handleChange}
              keyToChange="language"
              id={`newCampaignLanguage${key}`}
            />
          </div>
        </FlexContainer>
      )}
      <Input
        value={inputFieldState.notification_details[languageIndex].title}
        data-testid={`newCampaignTitle${key}`}
        onChange={(e) => handleChange("title", e)}
        id="sushi-input"
        label="Notification Title"
        helperText="&emsp;&emsp;Character Limit: 50"
        errorMsg={
          inputFieldState.notification_details[languageIndex].title.length > 50
            ? `Character Limit Exceeded by ${
                inputFieldState.notification_details[languageIndex].title
                  .length - 50
              } characters`
            : ""
        }
      />
      <br />
      <Textarea
        value={inputFieldState.notification_details[languageIndex].content}
        data-testid={`newCampaignContent${key}`}
        onChange={(e) => handleChange("content", e)}
        id="sushi-textarea"
        label="Message Content"
        borderColor={variables.primaryColor}
        innerWidth="100%"
        resize="none"
        className="mb-20"
        errorMsg={
          inputFieldState.notification_details[languageIndex].content.length >
          1500
            ? `Character Limit Exceeded by ${
                inputFieldState.notification_details[languageIndex].content
                  .length - 1500
              } characters`
            : ""
        }
        rows={5}
        helperText="&emsp;&emsp;Character Limit: 1500"
      />
      <PaginatedReactDropdown
        placeholder=""
        options={mediaTypeOptions}
        labelKey="label"
        valueKey="value"
        data-testid="mediaType"
        value={getInputLabel(
          inputFieldState.notification_details[languageIndex].media.type,
          mediaTypeOptions,
          "value",
          "label"
        )}
        handleChange={handleChange}
        keyToChange="type"
        className="mediaDropdown"
        isOptionDisabled={(option) => {
          return (
            (option == "Audio" || option == "Video") &&
            (!isPopup ||
              inputFieldState.notification_for == "Onboarding Applicants")
          );
        }}
        id={`mediaType${key}`}
      />
      {inputFieldState.notification_details[languageIndex].media.type ==
      "VIDEO" ? (
        <PaginatedReactDropdown
          options={videoOrientationOptions}
          labelKey="label"
          valueKey="value"
          data-testid={`orientationType${key}`}
          value={getInputLabel(
            inputFieldState.notification_details[languageIndex].media
              .orientation,
            videoOrientationOptions,
            "value",
            "label"
          )}
          handleChange={handleChange}
          keyToChange="orientation"
          placeholder="Select Orientation"
          labelWidth="30%"
          className="mediaDropdown"
          id={`orientationType${key}`}
        />
      ) : (
        ""
      )}
      {inputFieldState.notification_details[languageIndex].media.type ==
        "AUDIO" ||
      inputFieldState.notification_details[languageIndex].media.type ==
        "VIDEO" ? (
        <Input
          value={inputFieldState.notification_details[languageIndex].media.url}
          data-testid={`mediaURL${key}`}
          onChange={(e) => handleChange("url", e)}
          id="sushi-input"
          label={
            inputFieldState.notification_details[languageIndex].media.type ==
            "AUDIO"
              ? "Audio link (mp3 format or cdn link with m3u8 format)"
              : "Video link (cdn link with m3u8 format only)"
          }
        />
      ) : (
        ""
      )}

      {inputFieldState.notification_details[languageIndex].media.type ===
        "TEXT_ONLY" ||
      (!isPopup &&
        (inputFieldState.notification_details[languageIndex].media.type ===
          "AUDIO" ||
          inputFieldState.notification_details[languageIndex].media.type ===
            "VIDEO")) ? (
        ""
      ) : (
        <React.Fragment>
          <ImageUploadContainer justify={"flex-start"}>
            <UploadImageBar onClick={() => setModalState("image_upload")}>
              <CameraAdd
                color={variables.red500}
                className="mr-6 ml-10"
                size={20}
              />
              <span>
                Upload{" "}
                {inputFieldState.notification_details[languageIndex].media
                  .type === "VIDEO"
                  ? "Thumbnail"
                  : ""}{" "}
                Image
              </span>
            </UploadImageBar>
          </ImageUploadContainer>
          {inputFieldState.notification_details[languageIndex].image_name ? (
            <React.Fragment>
              <p className="font-10 mb-15 ml-16 text-grey">
                {inputFieldState.notification_details[languageIndex].image_name}
              </p>
            </React.Fragment>
          ) : (
            ""
          )}
          {!isPopup ? (
            <p className="font-10 mb-15 ml-16 text-grey opacity-5">
              {" "}
              This image will be shown within the notification details
            </p>
          ) : inputFieldState.notification_details[languageIndex].media.type ===
            "IMAGE" ? (
            ""
          ) : (
            <p className="font-10 mb-15 ml-16 text-grey opacity-5">
              {" "}
              This image will be shown on the pop-up only
            </p>
          )}
        </React.Fragment>
      )}
      {(
        <React.Fragment>
          <AddCTAContainer justify={"flex-start"}>
            <Button
              onClick={() => setModalState("cta")}
              data-testid="addctaBtn"
              className="sushi-btn mr-10 mt-14"
              appearance="outline"
              disabled={
                inputFieldState.notification_details[languageIndex].actions
                  .length >= 3
              }
            >
              {" "}
              Add CTA{" "}
            </Button>

            {inputFieldState.notification_details[languageIndex].actions.map(
              (ctaItem, index) => {
                return (
                  <FlexContainer className="flex-col ml-40">
                    <p className="mb-10 mt-8 text-grey">
                      CTA <b>{ctaItem.name}</b> Added
                    </p>
                    <DeleteBar onClick={() => handleCTADelete(index)}>
                      <Delete
                        className="mr-10"
                        size={20}
                        color={variables.red500}
                      />
                      <span>Delete</span>
                    </DeleteBar>
                  </FlexContainer>
                );
              }
            )}
          </AddCTAContainer>
          <p className="font-10 mb-24 ml-2 text-grey">
            Note: Maximum 3 CTAs can be assigned per campaign
          </p>
        </React.Fragment>
      )}
      {modalState && getModal()}
    </LanguageSection>
  );
};

const LanguageSection = styled.div`
  .sectionHeading {
    letter-spacing: 0.18rem;
    color: ${variables.grey600};
    margin-bottom: 1.75rem;
    font-size: 5px;
  }

  .langText {
    flex: 0 1 40%;
    height: 3rem;
    padding: 15px 15px 15px 5px;
    margin-bottom: 15px;
  }
  .langDropdown {
    flex: 0 1 60%;
    height: 50px;
    margin-bottom: 15px;
  }
  .contentField {
    height: 80%;
  }
  .mediaDropdown {
    width: 30%;
  }
  border-bottom: 1px solid ${variables.grey200};
`;
const AddCTAContainer = styled(FlexContainer)`
  margin: 1.75rem 0 1rem 0;
  border-top: 1px solid ${variables.grey200};
`;

const ImageUploadContainer = styled(FlexContainer)`
  margin: 2rem 0 0.5rem 0.5rem;
`;

const UploadImageBar = styled(FlexContainer)`
  cursor: pointer;
  span {
    color: ${variables.red500};
  }
`;

function mapStateToProps(state) {
  const { User } = state;
  return {
    uploadedImageName: User.uploadedImageName,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    uploadCampaignImage: bindActionCreators(
      DriverNotificationActions.uploadCampaignImage,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageContent);
